module.exports = __webpack_public_path__ + "img/star.2074e8a8.svg";